<template>
  <div class="h-2/3 flex">
    <div class="m-auto">
      <div class="grid grid-cols-1 justify-items-center h-full w-full">
        <div class="flex justify-center items-center">
          <svg-vue class="h-full h-auto w-24 mb-6" icon="undraw.task-list"></svg-vue>
        </div>
        <div class="flex justify-center items-center">
          <div class="w-full font-semibold text-xl">
            {{ $t('No records found') }}
          </div>
        </div>
        <template v-if="search">
          <div class="flex text-sm justify-center items-center">
            {{ $t('Try changing the filters, or rephrasing your search') }}.
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    search: { type: String|Object, default: null },
  },
};
</script>
